export const PageDataState = {
    Searchs: {
        ministry_id: {
            type: 'select',
            id: 'ministry_id',
            label: 'กระทรวง',
            value: '',
            placeholder: 'สังกัดกระทรวง',
        },
        office_department_name: {
            type: 'text',
            id: 'office_department_name',
            label: 'สำนักงาน / กรม',
            value: '',
            placeholder: 'สังกัดสำนักงาน / กรม',
        },
        office_department_status: {
            type: 'select',
            id: 'office_department_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        ministry_id: {
            type: 'text',
            id: 'ministry_id',
            label: 'สังกัดกระทรวง',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'สังกัดสำนักงาน / กรม',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}